import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Row,
  form,
  Col,
  Input,
  SelectPicker,
  Icon,
  Button,
  DatePicker,
  ControlLabel,
} from 'rsuite'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ReimbursementForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  ControlLabel,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  // const [formSchema, setFormSchema] = useState(props.schema)
  const [formSchema, setFormSchema] = useState(_schema)
  // console.log('tets2', _schema)
  const { handleSubmit } = useForm()
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const onSubmit = (data) => {
    console.log('data', data)
    setIsShowConfirm(true)
  }
  const handleCallService = () => {
    try {
      setIsShowConfirm(false)
    } catch (error) {}
  }
  return (
    <>
      <Panel collapsible defaultExpanded header={'จอง/เปลี่ยนงบ SAP'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>งวดที่ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.installment.name]} />
            <Input
              name={formSchema.installment.name}
              defaultValue={formSchema.installment.value}
              inputRef={register(isValidators(formSchema.installment.validators))}
              placeholder={'กรุณากรอก' + formSchema.installment.label}
              disabled={formSchema.installment.disabled}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeSap.name]} />
            <Controller
              name={formSchema.modeSap.name}
              control={control}
              defaultValue={formSchema.modeSap.value}
              rules={isValidators(formSchema.modeSap.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeSap.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>
      <hr />
      <Panel collapsible defaultExpanded header={'จอง/เปลี่ยนงบ e-Bud'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeEbus.name]} />
            <Controller
              name={formSchema.modeEbus.name}
              control={control}
              defaultValue={formSchema.modeEbus.value}
              rules={isValidators(formSchema.modeEbus.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeEbus.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>
      <hr />
      <Panel collapsible defaultExpanded header={'จอง/เปลี่ยนแก้ไขงบ e-From'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeEform.name]} />
            <Controller
              name={formSchema.modeEform.name}
              control={control}
              defaultValue={formSchema.modeEform.value}
              rules={isValidators(formSchema.modeEform.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeEform.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>

        <ConfirmWidget
          title={'ยืนยันการเบิกค่าทบทวน'}
          show={isShowConfirm}
          onCancle={() => setIsShowConfirm(false)}
          onConfirm={handleCallService}
        />
      </Panel>
      <hr />
    </>
  )
}
